// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"480":"51b0482c","515":"ba78ac58","663":"7b43270c","720":"f2d3fe85"}[chunkId] + ".chunk.js";
};